import { useCallback, useEffect, useMemo, useRef } from "react";

import { wsManuscriptEventUrl } from "utils/urls";

export function useManuscriptEvents({ spaceUuid, manuscriptId, enabled = true, onManuscriptChanged }) {
    const wsRef = useRef(null);
    const onManuscriptChangedRef = useRef(onManuscriptChanged);

    useEffect(() => {
        onManuscriptChangedRef.current = onManuscriptChanged;
    }, [onManuscriptChanged]);

    const connectionReady = useMemo(() => enabled && !!spaceUuid && !!manuscriptId, [enabled, manuscriptId, spaceUuid]);

    const handleMessage = useCallback((event) => {
        const data = JSON.parse(event.data || "{}");
        if (data?.type !== "manuscript_changed") {
            return;
        }
        onManuscriptChangedRef.current?.(data.payload || {});
    }, []);

    useEffect(() => {
        if (!connectionReady) {
            return undefined;
        }

        const socket = new WebSocket(wsManuscriptEventUrl(spaceUuid, manuscriptId));
        wsRef.current = socket;
        socket.onmessage = handleMessage;
        socket.onclose = () => {
            if (wsRef.current === socket) {
                wsRef.current = null;
            }
        };

        return () => {
            if (wsRef.current === socket) {
                wsRef.current = null;
            }
            socket.close();
        };
    }, [connectionReady, handleMessage, manuscriptId, spaceUuid]);
}

export default useManuscriptEvents;
